import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import { isNumber } from 'lodash';

import { ROSTER_CURRENT_BALANCE_FORM_NAME, InputMode } from 'Common/FormEnum';
import {
  RosterCurrentBalanceFieldEnum as Fields,
  ReportFieldEnum as CommonReportFields,
} from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { InputField, SelectField } from 'Common/SemanticWrapper';
import { YesNoOptions } from 'Common/FormHelper';
import { TitledCard } from 'Components/';
import CheckboxListComponent from 'Common/CheckboxListComponent';
import { getSelectedStatuses } from '../helpers/statusFormatter';
import { ExportTypeDropdown } from 'Common/ExportTypeDropdown';
import { formatDecimal } from 'Common/FormHelper';

class RosterCurrentBalanceFormContainer extends Component {
  AccountBalanceTypeOptions = [
    { value: 0, label: 'All' },
    { value: 1, label: 'Prepaid' },
    { value: 2, label: 'Balance Due' },
  ];

  SortByOptions = [
    { text: 'Last Name, First Name', value: 0 },
    { text: 'Serving Number', value: 1 },
    { text: 'Student Number', value: 2 },
    { text: 'Teacher', value: 3 },
    { text: 'Site', value: 4 },
  ];

  FilterOptions = [
    { text: 'Equal To', value: 0 },
    { text: 'Greater Than', value: 1 },
    { text: 'Less Than', value: 2 },
    { text: 'Not Equal To', value: 3 },
  ];

  preLoadTeacherOptions = [{ value: 'ALL', text: 'ALL' }];

  render() {
    const {
      loading,
      grades,
      teachers,
      shouldCustomFiltersDisable,
      loadingGrades,
    } = this.props;
    return (
      <Fragment>
        <Form name={ROSTER_CURRENT_BALANCE_FORM_NAME}>
          <Grid>
            <TitledCard title={'Filters'}>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={4}>
                    <Field
                      label={'Grade'}
                      name={Fields.Grade}
                      component={SelectField}
                      disabled={loading}
                      options={grades}
                      loading={loadingGrades}
                    />
                  </Grid.Column>
                  <Grid.Column width={6}>
                    <Field
                      label={'Teacher'}
                      name={Fields.Teacher}
                      component={SelectField}
                      disabled={loading}
                      options={
                        teachers.length > 0
                          ? teachers
                          : this.preLoadTeacherOptions
                      }
                    />
                  </Grid.Column>
                  <Grid.Column width={5}>
                    <Field
                      label={'Sort By'}
                      options={this.SortByOptions}
                      component={SelectField}
                      name={Fields.SortBy}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={6}>
                    <ReduxFormButtonGroup
                      label="Include Non LEA Students"
                      formName={ROSTER_CURRENT_BALANCE_FORM_NAME}
                      options={YesNoOptions}
                      fieldName={CommonReportFields.IncludeNonLeaStudents}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>

            <TitledCard title={'Account Balance'}>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column className="input-group--btn-group" width={3}>
                    <ReduxFormButtonGroup
                      label={'Show Balance'}
                      formName={ROSTER_CURRENT_BALANCE_FORM_NAME}
                      options={YesNoOptions}
                      fieldName={Fields.ShowBalance}
                      disabled={loading}
                    />
                  </Grid.Column>
                  <Grid.Column className="input-group--btn-group" width={7}>
                    <ReduxFormButtonGroup
                      label={'Account Balance'}
                      formName={ROSTER_CURRENT_BALANCE_FORM_NAME}
                      options={this.AccountBalanceTypeOptions}
                      fieldName={Fields.AccountBalanceType}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={3}>
                  <Grid.Column className="input-group--btn-group" width={4}>
                    <ReduxFormButtonGroup
                      label={'Use Custom Balance Filter'}
                      formName={ROSTER_CURRENT_BALANCE_FORM_NAME}
                      options={YesNoOptions}
                      fieldName={Fields.UseCustomBalanceFilter}
                      disabled={loading}
                    />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Field
                      label={'Filter'}
                      component={SelectField}
                      options={this.FilterOptions}
                      disabled={loading || shouldCustomFiltersDisable}
                      name={Fields.CustomBalanceFilter}
                    />
                  </Grid.Column>
                  <Grid.Column width={4}>
                    <Field
                      label={'Dollar Amount'}
                      component={InputField}
                      disabled={loading || shouldCustomFiltersDisable}
                      name={Fields.BalanceAmount}
                      mode={InputMode.Decimal}
                      numericSize={[12, 2]}
                      allowNegative={true}
                      formatOnBlur={formatDecimal(2, false)}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>

            <TitledCard title={'Status'}>
              <Grid>
                <Grid.Row>
                  <Grid.Column className="input-group--btn-group" width={5}>
                    <ReduxFormButtonGroup
                      label={'Show Status'}
                      formName={ROSTER_CURRENT_BALANCE_FORM_NAME}
                      options={YesNoOptions}
                      fieldName={Fields.ShowStatus}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <CheckboxListComponent
                    {...this.props}
                    showAll={true}
                    title={'status'}
                    displayItems={this.props.statusCheckboxes}
                  />
                </Grid.Row>
              </Grid>
            </TitledCard>
            <TitledCard title={'Report Options'}>
              <Grid>
                <Grid.Row>
                  <Grid.Column className="input-group--btn-group" width={7}>
                    <ReduxFormButtonGroup
                      label={'Show Parent Contact Info'}
                      formName={ROSTER_CURRENT_BALANCE_FORM_NAME}
                      options={YesNoOptions}
                      fieldName={Fields.ShowParentContactInformation}
                      disabled={loading}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <ExportTypeDropdown upward />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </TitledCard>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = (values) => {
  const errors = {};

  // If Custom Balance Filter is enabled
  if (values[Fields.UseCustomBalanceFilter]) {
    if (
      values[Fields.CustomBalanceFilter] === undefined ||
      values[Fields.CustomBalanceFilter] === null
    ) {
      errors[Fields.CustomBalanceFilter] =
        'Filter is required when using the custom balance filter';
    }
    if (!isNumber(Number(values[Fields.BalanceAmount]))) {
      errors[Fields.BalanceAmount] =
        'Dollar Amount is required when using the custom balance filter';
    }
  }
  if (getSelectedStatuses(values).length === 0) {
    errors[Fields.ShowStatus] = 'At least one status must be selected';
  }

  return errors;
};

export const RosterCurrentBalanceForm = reduxForm({
  form: ROSTER_CURRENT_BALANCE_FORM_NAME,
  validate,
  enableReinitialize: true,
})(withRouter(connect()(RosterCurrentBalanceFormContainer)));



// WEBPACK FOOTER //
// ./src/pages/rostercurrentbalance/components/RosterCurrentBalanceForm.js